import {
  Box,
  css,
  genesisStyled,
  SubtleButton,
} from '@leagueplatform/genesis-commons';
import { Icon, ICONS } from '@leagueplatform/ui-kit';
import * as React from 'react';

type ArrowButtonProps = {
  direction: 'back' | 'forward';
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
};

const StyledArrowButton = genesisStyled(SubtleButton)(
  css({
    borderRadius: 'circle',
    height: 'two',
    paddingInlineStart: '0',
    paddingInlineEnd: '0',
    width: 'two',
  }),
);

const ArrowContainer = genesisStyled(Box)(
  css({
    as: 'span',
    display: 'block',
    marginTop: '-0.225em',
  }),
);

export const ArrowButton = ({
  ariaLabel,
  direction,
  onClick,
  disabled,
}: ArrowButtonProps) => {
  const arrowIcon =
    direction === 'back' ? ICONS.BACK_CHEVRON : ICONS.FORWARD_CHEVRON;

  return (
    <Box>
      <StyledArrowButton
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
      >
        <ArrowContainer>
          <Icon size={16} icon={arrowIcon} />
        </ArrowContainer>
      </StyledArrowButton>
    </Box>
  );
};
